var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.824,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.37068 6C9.2042 6.08029 10.0204 6.24033 10.8194 6.48014C10.6857 7.53844 10.5096 8.59476 10.2913 9.64908C11.2556 12.7479 12.8241 15.4847 14.9966 17.8595C17.2353 19.6303 19.7961 20.5265 22.6789 20.5483C23.5122 20.5722 24.3443 20.5722 25.1757 20.5483C25.2557 20.6283 25.3357 20.7084 25.4157 20.7884C25.4798 21.1405 25.4798 21.4926 25.4157 21.8447C24.5571 22.3781 23.7408 22.9702 22.967 23.6212C20.8189 24.9129 18.5142 25.297 16.053 24.7736C11.9166 23.7725 8.82769 21.4198 6.78621 17.7155C5.45968 14.5957 5.81178 11.6829 7.84252 8.97688C7.87453 8.17665 7.90655 7.37641 7.93855 6.57617C8.01577 6.32209 8.15981 6.13003 8.37068 6Z",
    fill: "#0E0A02"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46671 6.28809C9.13792 6.41592 9.81012 6.54395 10.4833 6.6722C10.3234 7.63222 10.1633 8.5925 10.0032 9.55305C9.67102 9.55005 9.35093 9.48603 9.04288 9.361C9.01958 8.62193 9.01958 7.88571 9.04288 7.15234C8.89738 7.34894 8.81736 7.57301 8.80281 7.82454C8.78632 8.27605 8.7383 8.72418 8.65876 9.16894C8.48994 9.10864 8.34589 9.01262 8.22664 8.88086C8.16261 8.11263 8.16261 7.3444 8.22664 6.57617C8.32699 6.4923 8.40701 6.39627 8.46671 6.28809Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0826 9.16895C8.27143 9.25933 8.46348 9.35536 8.65877 9.45703C8.96277 13.5694 10.5953 17.0424 13.5562 19.8761C16.6057 22.206 19.9987 22.8622 23.7352 21.8447C23.8946 21.9683 24.0546 22.0963 24.2154 22.2288C22.0453 24.2375 19.4845 25.0218 16.5331 24.5815C12.7722 23.7945 9.8114 21.8259 7.65047 18.6758C5.66871 15.3998 5.81275 12.2308 8.0826 9.16895Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94685 9.64909C9.32131 9.69376 9.68942 9.75778 10.0512 9.84115C10.873 12.4776 12.1214 14.8783 13.7963 17.0433C15.6071 19.0612 17.8638 20.2616 20.5663 20.6444C21.6519 20.7668 22.7402 20.8469 23.8313 20.8844C23.8313 21.1085 23.8313 21.3326 23.8313 21.5566C17.6951 23.0283 13.2298 20.9476 10.4353 15.3148C9.5633 13.5232 9.06715 11.6346 8.94685 9.64909Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.27465 14.0664C8.81199 14.173 8.87601 14.3971 8.46671 14.7386C8.16298 14.6018 8.09895 14.3777 8.27465 14.0664Z",
    fill: "#130F03"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9237 16.083C12.2383 16.1427 12.3663 16.3348 12.3078 16.6591C11.9929 16.6082 11.8649 16.4161 11.9237 16.083Z",
    fill: "#090701"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3114 20.7884C25.0962 20.5968 25.3683 20.8849 25.1277 21.6526C24.8482 21.9339 24.5281 21.9979 24.1674 21.8447C24.0751 21.4613 24.1231 21.1092 24.3114 20.7884Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2681 20.9804C13.6979 21.0092 13.826 21.2173 13.6522 21.6046C13.2 21.6125 13.072 21.4044 13.2681 20.9804Z",
    fill: "#100B02"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4371 22.6129C16.8173 22.5717 17.1534 22.6678 17.4454 22.901C17.5094 23.029 17.5094 23.1571 17.4454 23.2851C17.0122 23.4706 16.6601 23.3745 16.3891 22.9971C16.3335 22.8599 16.3495 22.7318 16.4371 22.6129Z",
    fill: "#0A0701"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6688 22.901C16.0213 22.9675 16.1173 23.1596 15.9569 23.4772C15.6668 23.3549 15.5708 23.1629 15.6688 22.901Z",
    fill: "#141003"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "white",
    fillOpacity: 0.06
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanana);
export default __webpack_public_path__ + "static/media/BANANA.70f2ffc810f370d98f39d9b760b745fc.svg";
export { ForwardRef as ReactComponent };